import { render, staticRenderFns } from "./LabelContractsSplitsEditPanelDialog.vue?vue&type=template&id=19d0a44b"
import script from "./LabelContractsSplitsEditPanelDialog.vue?vue&type=script&lang=js"
export * from "./LabelContractsSplitsEditPanelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports